// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"829":"7ca156bc","910":"0bb6ef19"}[chunkId] + ".chunk.css";
};